/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export type ReportsFindCoordinatesAnimalTypeItem =
  (typeof ReportsFindCoordinatesAnimalTypeItem)[keyof typeof ReportsFindCoordinatesAnimalTypeItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesAnimalTypeItem = {
  vertebrate: 'vertebrate',
  invertebrate: 'invertebrate',
} as const;
